function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152 684a342 342 0 100-684 342 342 0 000 684z",
  fill: "#285680"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152 0C104 0 59 10 18 27 16 38 7 58 7 64c1 0 87-88 76-29-6 38-76 38-73 77 73 28 99-55 161-55 21 0 75-33 85-26 41 27-10 123-41 91-31-30-74 11-72 58 16 1 23-44 37-29 15 16 10 50-12 58s-107-58-86-8c23 55-69 97 24 75 44-10 29 23 50 39 24 19 14-26 32-19 26 10-5 36 36 17 48-22 30 12 45 34 27 42 95 82 130 27 9-13 3-116 56-47 33 44 22-51 27-77A342 342 0 00152 0z",
  fill: "#24AE5F"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198 496l-63-47-42 2-44-14-34-24-78 18-32 16-36 48 13 56 11 14 66 31 45 6 26 54 1 6a341 341 0 00206 11l9-53 41-33 17-53-85-1-21-37z",
  fill: "#FAC176"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164 625c-13-1-60-16-71-35-11-20-34-53-35-48-1 4-108-32-181-58l-8 11 13 56 11 14 66 31 45 6 26 54 1 6a341 341 0 00206 11l7-40-21-8c-33-13-46 1-59 0z",
  fill: "#88C057"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M287 587l17-53-85-1-21-37-63-47-42 2-44-14-34-24-78 18-32 16-28 37c73 26 180 62 181 58 1-5 24 28 35 48 11 19 58 34 71 35s26-13 59 0l21 8 2-13 41-33z",
  fill: "#88C057"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M281 25l-4 75-66 66s62 88 66 98c4 11 55 23 66 17 10-6 49-39 66-17 11 16 10 30 17 40 5 0 11 3 18 11l34 9c4-21 1-59 4-74A343 343 0 00281 25z",
  fill: "#24AE5F"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M321 45l-4 73-47 47s44 63 47 71c3 7 40 16 47 12 8-5 36-28 47-12 12 16 5 29 24 35l45 12c0-14 0-26 2-33-25-87-83-161-161-205z",
  fill: "#1F9451"
});

var SvgEarth = function SvgEarth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 494,
    height: 537,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEarth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/earth.41f2d874.svg";
export { ForwardRef as ReactComponent };